import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { Component } from "react";
import { BsBuilding } from "react-icons/bs";
import BasicDataGrid from "../../ui/BasicDataGrid";
import {  MdDelete, MdEdit } from "react-icons/md";
import NomeInput from "../../ui/NomeInput";
import { httpGet, httpPost } from "../../util/http";
import StatusAlert from "../../ui/StatusAlert";
import UnidadeSelect from "../../ui/UnidadeSelect";
import CodDepInput from "../../ui/CodDep";
import RoundButton from "../../ui/RoundButton";

export default class Depositos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showForm: false,
            showDelete: false,
            depositos: [],
        }
        this.columns = [
            { field: 'deposito', headerName: 'Depósito', flex: 1, valueGetter: (params) => params.row?.nome },
            { field: 'coddep', headerName: 'Núm. Dép.', flex: 1, valueGetter: (params) => params.row?.sapiens_coddep },
            { field: 'unidade', headerName: 'Unidade', flex: 1, valueGetter: (params) => params.row?.unidade?.nome },
            {
                field: 'action', headerName: 'Ações', width: 100, renderCell: (params) => <>
                    <IconButton title="Editar" onClick={e => this.onEditClick(params)} color="primary"><MdEdit size={16} /></IconButton>
                    <IconButton title="Remover" onClick={e => this.onRemoveClick(params)} color="primary"><MdDelete size={16} /></IconButton>
                </>
            },
        ];
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/depositos/list',
            depositos => {
                //console.log(depositos)
                this.setState({
                    depositos: depositos,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.nome || this.state.nome.length < 3) {
            this.setState({ nomeErr: true })
            return;
        }

        if (this.state.unidade == null) {
            this.setState({ unidadeErr: true })
            return;
        }


        if (!this.state.codDep) {
            this.setState({ codDepErr: true })
            return;
        }

        this.setState({
            showAlert: false,
            btnLoading: true
        });

        httpPost('/depositos/save',
            {
                id: this.state.currId,
                nome: this.state.nome,
                unidadeId: this.state.unidade?.id,
                coddep: this.state.codDep,
            },

            resp => {
                this.refresh();
                this.setState({ showForm: false });
            },

            error => {
                this.setState({
                    showAlert: true,
                    btnLoading: false,
                    msg: 'Falha ao salvar.',
                    extraMsg: error.message
                });
            },

            false
        );
    }

    onDelete(e) {
        e.preventDefault();

        this.setState({
            showAlert: false,
            btnLoading: true
        });

        httpPost('/depositos/' + this.state.currId + '/delete',
            {
                delete: true
            },

            resp => {
                this.refresh();
                this.setState({ showDelete: false });
            },

            error => {
                this.setState({
                    showAlert: true,
                    btnLoading: false,
                    msg: 'Falha ao salvar.',
                    extraMsg: error.message
                });
            },

            false
        );
    }

    onAddClick() {
        this.setState({
            currId: undefined,
            showForm: true,
            nome: '',
            nomeErr: false,
            unidade: null,
            unidadeErr: false,
            codDep: '',
            codDepErr: false,
            showAlert: false,
            btnLoading: false,
        });
    }

    onEditClick(params) {
        this.setState({
            currId: params.row?.id,
            showForm: true,
            nome: params.row?.nome,
            nomeErr: false,
            codDep: params.row?.sapiens_coddep,
            codDepErr: false,
            unidade: params.row?.unidade,
            unidadeErr: false,
            showAlert: false,
            btnLoading: false,
        });
    }

    onRemoveClick(params) {
        this.setState({
            currId: params.row?.id,
            showDelete: true,
            showAlert: false,
            btnLoading: false,
        });
    }

    render() {
        return (
            <Stack>
                <Dialog open={this.state.showDelete}>
                    <form onSubmit={event => this.onDelete(event)}>
                        <DialogTitle color="primary" fontSize={12}>REMOVER DEPÓSITO</DialogTitle>
                        <DialogContent>
                            <Stack width={400} gap={2} mt={1}>
                                <Typography variant="caption">Tem certeza que deseja remover?</Typography>
                            </Stack>
                            {this.state.showAlert &&
                                <Stack mt={1} width="calc(100%)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} /></Stack>}
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <RoundButton submit>Sim</RoundButton>}
                            <RoundButton disabled={this.state.btnLoading} onClick={e => this.setState({ showDelete: false })}>Não</RoundButton>
                        </DialogActions>
                    </form>
                </Dialog>
                {/* ---------------------------------------------------------------------- */}
                <Dialog open={this.state.showForm}>
                    <form onSubmit={event => this.onSubmit(event)}>
                        <DialogTitle color="primary" fontSize={12}>{this.state.currId ? "EDITAR DEPÓSITO" : "ADICIONAR DEPÓSITO"}</DialogTitle>
                        <DialogContent>
                            <Stack width={400} gap={2} mt={1}>
                                <NomeInput value={this.state.nome} onChange={(nome) => this.setState({ nome, nomeErr: false })} error={this.state.nomeErr} />
                                <Stack direction="row" gap={2}>
                                    <UnidadeSelect sx={{ flex: 1 }} value={this.state.unidade} onChange={(unidade) => this.setState({ unidade, unidadeErr: false })} error={this.state.unidadeErr} />
                                    <CodDepInput value={this.state.codDep} sx={{ width: 150 }} onChange={(codDep) => this.setState({ codDep, codDepErr: false })} error={this.state.codDepErr} />
                                </Stack>
                                {this.state.showAlert &&
                                    <Stack mt={1} width="calc(100%)"><StatusAlert type="err" msg={this.state.msg} extra={this.state.extraMsg} /></Stack>}
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <RoundButton submit>Salvar</RoundButton>}
                            <RoundButton disabled={this.state.btnLoading} onClick={e => this.setState({ showForm: false })}>Cancelar</RoundButton>
                        </DialogActions>
                    </form>
                </Dialog>
                {/* ---------------------------------------------------------------------- */}
                <Stack direction="row" borderBottom={1} borderColor="primary.main">
                    <Typography variant="body2" color="primary"><BsBuilding size={16} /><Box ml={1} component="span"><b>Cadastro de depositos</b></Box></Typography>
                </Stack>
                <Typography mt={1} variant="caption" color="primary">Cadastre aqui todos os depósitos.</Typography>
                <Box><Button color="btnStyle" onClick={e => this.onAddClick()} size="small" variant="contained" disableElevation>Cadastrar</Button></Box>
                <Box mt={1}>
                    <BasicDataGrid
                        dense
                        props={{
                            //onRowClick: e => this.onUnidFichaClick(),
                            loading: this.state.loading
                        }} rows={this.state.depositos} columns={this.columns} />
                </Box>
            </Stack>
        );
    }
}
